module.exports = __webpack_public_path__ + "img/flexible-payment-options.910a7b4f.jpg";